
class ExcerptMore extends HTMLElement {
  constructor() {
    super()

    this.content = this.querySelector('[data-content]')

    if(this.content.children.length < 2) return

    this.settings = {
      opened: false,
      moreText: this.dataset.openText,
      lessText: this.dataset.closeText
    }

    this.classList.add('excerpt-more')


    this.toggler = this.querySelector('[data-button]')
    this.toggler.addEventListener('click', this.toggleContent.bind(this))

    this.wrap = document.createElement('div')
    this.wrap.classList.add('excerpt-more__content', 'rte')
    this.wrap.style.height = '0px'


    Array.from(this.content.children).forEach((child, index) => {
      if(index > 0) {
        this.wrap.appendChild(child)
      }
    })

    this.content.appendChild(this.wrap)

  }

  toggleContent() {

    if(this.settings.opened) {
      this.classList.remove('excerpt-more--opened')
      this.settings.opened = false
      this.toggler.children[0].innerText = this.settings.moreText
      this.slideUp(this.wrap)
    } else {
      this.classList.add('excerpt-more--opened')
      this.settings.opened = true
      this.toggler.children[0].innerText = this.settings.lessText
      this.slideDown(this.wrap)
    }

  }

  handleTabindex(wrapper, value) {
    const clickable = Array.from(wrapper.querySelectorAll('a, button'))

    if (clickable) {
      clickable.forEach((item) => {
        item.setAttribute('tabindex', value)
      })
    }
  }

  slideDown(el, cssHeight, checkScroll = false) {
    if (el) {
      el.classList.add('open')

      this.handleTabindex(el, '0')

      if (cssHeight) {
        el.style.height = cssHeight
      } else {
        el.style.height = el.scrollHeight + 'px'
      }

      if (checkScroll) {
        if (el.scrollHeight > window.innerHeight) {
          el.classList.add('o-scroll')
        }
      }

    }
  }

  slideUp(el) {
    if (el) {
      el.style.height = '0px'

      this.handleTabindex(el, '-1')

      el.classList.remove('open')
      el.classList.remove('o-scroll')
    }
  }

}
customElements.define('excerpt-more', ExcerptMore)
